import React from "react";

import Chip from "@material-ui/core/Chip";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";

import RbChipList from "components/RbChipList";
import RbFlexTableCell from "components/RbFlexTableCell";
import RbFlexTableRow from "components/RbFlexTableRow";
import useFormatters from "hooks/useFormatters";

import ProductDetail from "./ProductDetail";

function ProductRow(props) {
  const { product } = props;

  const { pathname } = useLocation();

  const { formatCurrency } = useFormatters();

  const history = useHistory();

  const handleRowClick = React.useCallback(
    (item) => {
      history.push(`${pathname}/${item.id}`);
    },
    [history, pathname]
  );

  return (
    <RbFlexTableRow
      onClick={() => handleRowClick(product)}
      renderExpand={() => <ProductDetail product={product} />}
    >
      <Hidden mdDown>
        <RbFlexTableCell flex="0 60px">{product.id}</RbFlexTableCell>
      </Hidden>
      <RbFlexTableCell>
        <Typography display="block">{product.name}</Typography>
        <Typography display="block" variant="caption" noWrap>
          {product?.manufacturer?.name}
        </Typography>
      </RbFlexTableCell>
      <RbFlexTableCell flex="0 80px" align="right">
        {formatCurrency(product.price)}
      </RbFlexTableCell>
      <Hidden mdDown>
        <RbFlexTableCell flex="0 80px" align="right">
          {product.inventory}
        </RbFlexTableCell>
      </Hidden>
      <Hidden mdDown>
        <RbFlexTableCell>
          <RbChipList size="small">
            {product?.categories?.map((category) => (
              <Chip key={category.id} label={category.name} />
            ))}
          </RbChipList>
        </RbFlexTableCell>
      </Hidden>
    </RbFlexTableRow>
  );
}

ProductRow.propTypes = {
  product: PropTypes.shape({
    categories: PropTypes.array,
    id: PropTypes.string,
    inventory: PropTypes.number,
    manufacturer: PropTypes.shape({
      name: PropTypes.string,
    }),
    name: PropTypes.string,
    price: PropTypes.number,
  }).isRequired,
};

export default React.memo(ProductRow);
